import shopSearch from "../../../common/ShopSearch";
import shopsReviewsNew from "../ShopsReviewsNew/index";

export default {
  mixins: [shopsReviewsNew],
  mounted: function() {
    shopSearch("review_form_shop_id");
  }
};
